import React from "react";
export const ValidationErrors = ({ mutationValidationErrors, title, children }) => {
    const errors = mutationValidationErrors || [];
    const validationErrors = errors.map((error, i) => {
        return React.createElement("li", { key: i }, error.message);
    });
    return (React.createElement("div", { style: { display: "inline-block" } },
        React.createElement("p", null, title),
        errors.length > 0 && React.createElement("ul", null, validationErrors),
        children));
};
